import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined'
import DashboardIcon from '@mui/icons-material/Dashboard'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import DevicesIcon from '@mui/icons-material/Devices'
import GroupsIcon from '@mui/icons-material/Groups'
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer'
import { isCompanyCountryFrance } from '@/lib/country/entityCountries'
import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { routeFrontOfficeGroupNews } from '@/lib/routes/front/common/routeFrontOfficeGroupNews'
import { routeFrontOfficeInvoices } from '@/lib/routes/front/common/routeFrontOfficeInvoices'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'
import { STEP } from '@/types/enum/userCompanyGenericEditor'

export const getFrontOfficeGroupPharmacien = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord',
    t: 'routes.frontoffice.group.dashboard',
    icon: DashboardIcon,
    href: '/frontoffice/group/home',
    home: true,
    menuHeader: true,
    position: 0,
  },
  {
    // Fiche de l'officine (onglet « Entreprise » de Mon profil). Premiere entree de « Ma
    // pharmacie », AVANT « Contrat » (position 30) : c'est le point d'entree du controle de
    // compte (fiche, segmentation, coordonnees bancaires), jusqu'ici atteignable seulement
    // par l'avatar. Le `?q=` passe par `queryParams` — un href avec query casserait le
    // controle d'acces et l'etat actif, qui comparent le pathname nu.
    route: 'MyCompany',
    text: 'Mon entreprise',
    t: 'routes.frontoffice.group.myCompany',
    icon: BusinessOutlinedIcon,
    href: '/frontoffice/group/my-profile',
    queryParams: { q: STEP.COMPANY_INFORMATION },
    menuHeader: true,
    menuGroup: MENU_GROUPS.PHARMACY,
    position: 20,
  },
  {
    route: 'TeamsList',
    text: 'Equipe officinale',
    t: 'routes.frontoffice.all.teamsList',
    icon: GroupsIcon,
    href: '/frontoffice/group/user-team/user-team-list',
    menuHeader: true,
    position: 120,
    isMobile: false,
  },
  {
    // Plus dans le menu : accès via une carte « Mes missions » sur la home (cf GameMissionCards).
    route: 'GamePronostic',
    text: 'Coupe du Monde 2026',
    t: 'routes.frontoffice.group.game',
    icon: SportsSoccerIcon,
    href: '/frontoffice/group/game-pronostic',
    menuHeader: false,
    position: 130,
  },
  {
    route: 'editUser',
    text: "Editer un membre de l'équipe",
    t: 'routes.frontoffice.all.teamUserEdit',
    href: '/frontoffice/group/user-team/edit-user-team/[userId]',
  },
  {
    route: 'TeamUserAdd',
    text: "Ajouter un membre de l'équipe",
    t: 'routes.frontoffice.all.teamUserAdd',
    href: '/frontoffice/group/user-team/add-user-team',
  },
  // Espace « par fonction » du titulaire (toutes entités confondues).
  ...routeFrontOfficeInvoices,
  {
    // Fiche CLOSE (une fiche par SIREN) : l'ancien titulaire retrouve, en LECTURE SEULE, les
    // commandes du compte boutique de SA société — celui que porte la fiche close (D-4 révisé,
    // demande de Mathieu du 15/10/2026). « Mes commandes » de la centrale n'est pas proposé sur
    // une fiche close (section « Ma pharmacie » seule) : cette entrée le remplace, dans « Ma
    // pharmacie », et seulement si la fiche close a un compte boutique. Même page, même endpoint
    // en lecture (`GET /companies/{id}/store_orders`), sans geste de commande.
    route: 'ClosedCompanyStoreOrders',
    text: 'Mes commandes',
    t: 'routes.frontoffice.store.orders',
    icon: ReceiptLongIcon,
    href: '/frontoffice/store/orders',
    menuHeader: true,
    menuGroup: MENU_GROUPS.PHARMACY,
    position: 115,
    fnDisplay: ({ dataMyProfile }) =>
      !!dataMyProfile?.selectCompanyDefault?.closedAt && !!dataMyProfile?.selectCompanyDefault?.userIdStore,
  },
  {
    route: 'ContractsOverview',
    text: 'Mes contrats',
    t: 'routes.frontoffice.group.contractsOverview',
    icon: DescriptionOutlinedIcon,
    href: '/frontoffice/group/contracts-overview',
    // Retirée des menus (doublon avec « Contrat » /frontoffice/group/contracts — décision
    // utilisateur 2026-07-19 : on garde la page contrats par entité). Page accessible par URL.
    menuHeader: false,
    position: 115,
  },
  {
    route: 'Sales',
    text: 'Mes abonnements',
    t: 'routes.frontoffice.all.sales',
    icon: CreditCardOutlinedIcon,
    href: '/frontoffice/group/billing/sales-invoices',
    menuHeader: true,
    position: 118,
    isMobile: false,
  },
  {
    // Partenariats laboratoire de la pharmacie : contrats (cadre + applications, statut) et
    // preferences PLV editables, un onglet par laboratoire avec son logo.
    route: 'MyPartnersGroup',
    text: 'Mes partenaires',
    mobileText: 'Partenaires',
    t: 'routes.frontoffice.group.myPartners',
    icon: HandshakeOutlinedIcon,
    href: '/frontoffice/group/my-partners',
    // HORS menu (2026-08-19) : la section dediee « Mes partenaires » du menu lateral
    // (PartnersNavSection) porte desormais UNE entree PAR laboratoire (logo) vers cette
    // page — la route reste declaree pour l'acces URL et la resolution des helpers.
    menuHeader: false,
    position: 890,
    // France uniquement (regle projet n°8) + au moins un laboratoire partenaire OUVERT aux
    // pharmacies (le flag serveur my_partners a ete supprime — feature ouverte partout,
    // 2026-08-19). Un labo n'est ouvert que si son espace personnalise ET son « Onboarding
    // pharmacies » sont actifs : c'est ce qui permet de rattacher les officines en amont
    // (import du tag partenaire) sans rien exposer cote pharmacien. Meme regle que
    // PartnerContractRequirementMeProvider — sans elle, la route menerait a une page vide.
    fnDisplay: ({ dataMyProfile }) =>
      isCompanyCountryFrance({ country: dataMyProfile?.selectCompanyDefault?.country }) &&
      !!dataMyProfile?.selectCompanyDefault?.partners?.some(
        partner => partner?.activeEspacePersonnalise && partner?.onboardingActive
      ),
    isMobile: false,
  },
  {
    // Materiel detenu par la pharmacie, TOUTES ENTITES : enceintes Sound et PLV fixes
    // envoyees par les laboratoires (ancienne page Sound, deplacee ici).
    // Nom DISTINCT de la route Sound historique (`myEquipments`) : les deux coexistent, et
    // getRouteFrontPathByNameSync doit pouvoir viser la nouvelle sans ambiguite (la page Sound
    // redirige ici — un nom commun creerait une boucle).
    route: 'MyEquipmentsGroup',
    text: 'Mes équipements',
    mobileText: 'Equipements',
    // Cle propre a l'ecran transverse : la cle Sound dit « Mon equipement » (une enceinte),
    // ici la liste couvre plusieurs materiels de plusieurs entites.
    t: 'routes.frontoffice.group.myEquipments',
    icon: DevicesIcon,
    href: '/frontoffice/group/my-equipments',
    menuHeader: true,
    // Rangee dans « Ma pharmacie », avant les guides.
    position: 900,
    // France uniquement (regle projet n°8). Cote PHARMACIEN, le perimetre pays est celui de SA
    // pharmacie : `dataMyProfile.countries` est le perimetre d'un admin back-office, vide ici —
    // s'en servir masquerait l'entree pour tout le monde.
    fnDisplay: ({ dataMyProfile }) =>
      isCompanyCountryFrance(dataMyProfile?.selectCompanyDefault),
  },
  {
    // Base documentaire TRANSVERSE (sections par entite sur la page) — meme id que les
    // declarations par entite (Sound/Insight/StoreBag) : en menu v2 le dedoublonnage
    // href+route n'en garde qu'UNE, rangee dans « Ma pharmacie ».
    route: 'GuidesDocumentations',
    text: 'Guides & Documentations',
    t: 'routes.frontoffice.group.documentation',
    icon: MenuBookIcon,
    href: '/frontoffice/group/documentation',
    menuHeader: true,
    // Derniere entree de « Ma pharmacie », APRES « Mes tickets » (position 910).
    position: 920,
  },
  ...routeFrontOfficeCommonUser,
  ...routeFrontOfficeGroupNews,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_PHARMACIEN],
}))
